module.exports = __webpack_public_path__ + "static/media/logovc.53048c2d.png";